export default __webpack_public_path__ + "static/media/upload.bd2d3463.svg";